import { Injectable } from '@angular/core';
import { DocumentSigning } from "@models/documents/document-signing";
import {
  ESignBody,
  ESignBulkModel,
  PaperSignBody,
  SendBulkEsignModel,
  UpdateRecipientInfoModel
} from "@models/documents/sign-documents";
import {
  ProviderConnectionStatus
} from "@shared/components/documents-related/sign-integrations-dropdown/model/provider-connection-status";
import BaseApiService from "@shared/services/base/base-api.service";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ESignApiService extends BaseApiService {
  sendToESign(documentId: string, signBody: ESignBody): Observable<DocumentSigning> {
    return this.api.post<DocumentSigning>(`${ this.apiUrl }/e-sign/${ documentId }/send`, signBody);
  }

  sendToEsignBulk(esignBody: SendBulkEsignModel): Observable<ESignBulkModel> {
    return this.api.post<ESignBulkModel>(`${ this.apiUrl }/e-sign/bulk/send`, esignBody);
  }

  getEsignBulkModel(documentsId: string[]): Observable<ESignBulkModel> {
    return this.api.post<ESignBulkModel>(`${ this.apiUrl }/e-sign/bulk/model`, documentsId);
  }

  resendESign(documentId: string, resendModel: UpdateRecipientInfoModel): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/e-sign/${ documentId }/email/resend`, resendModel);
  }

  voidEnvelope(documentId: string): Observable<unknown> {
    return this.api.put<unknown>(`${ this.apiUrl }/e-sign/${ documentId }/void`, {});
  }

  voidPaperSign(documentId: string): Observable<unknown> {
    return this.api.put<unknown>(`${ this.apiUrl }/e-sign/${ documentId }/paper/void`, {});
  }

  markAsSign(documentsId: string[], signedDate: string): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/e-sign/mark-as-signed?signedDate=${ signedDate }`, documentsId);
  }

  paperSign(documentId: string, paperSignBody: PaperSignBody): Observable<DocumentSigning> {
    return this.api.post<DocumentSigning>(`${ this.apiUrl }/e-sign/${ documentId }/paper`, paperSignBody);
  }

  getESignProvidersStatus(): Observable<ProviderConnectionStatus[]> {
    return this.api.get<ProviderConnectionStatus[]>(`${ this.apiUrl }/providers/e-sign/status`);
  }

  markAsSent(ids: string[]): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/e-sign/mark-as-sent`, ids);
  }
}
